<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="alert alert-info" role="alert">
          Bienvenido
        </div>
      </div>
    </div>

  </div>

</template>

<script>

// import L from 'leaflet';

export default {
  name: 'Home-View',
  components: {
  },
  props: {

  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style scoped>

</style>
